import React, { useCallback, useState } from 'react'
import { APIService } from 'api/APIService'
import { useObject } from 'src/hooks/useObject'
import { AppButton } from 'components/FormElements/AppButton/AppButton'
import { ShadowInput } from 'components/FormElements/ShadowInput/ShadowInput'
import styles from '../Form.module.scss'

type ChangePasswordFormProps = {
  onSuccess: () => void,
  onError: (e: Error) => void,
}

/** New password for a signed-in client, in the personal data tab */
export const ChangePasswordForm: React.FC<ChangePasswordFormProps> = ({ onSuccess, onError }) => {
  const [formData, setFormField] = useObject({ password: '', passwordConfirm: '' })
  const [passwordsEmpty, setPasswordsEmpty] = useState(false)
  const [loading, setLoading] = useState(false)
  const { password, passwordConfirm } = formData
  const mismatch = !!(password.length && passwordConfirm.length && password !== passwordConfirm)

  const setField = (field: keyof typeof formData) => (value: string) => {
    setFormField(field, value)
    setPasswordsEmpty(false)
  }

  const handleSubmit = useCallback(async (e: React.MouseEvent) => {
    e.preventDefault()
    if (!password.length || !passwordConfirm.length) {
      setPasswordsEmpty(true)
      return
    }
    setLoading(true)
    try {
      await APIService.profile.editProfile({ password, passwordConfirm })
      setLoading(false)
      onSuccess()
    } catch (err) {
      setLoading(false)
      onError(err as Error)
    }
  }, [password, passwordConfirm, onSuccess, onError])

  return (
    <div className={styles.form}>
      <div className={styles.fields}>
        {([['password', 'Новый пароль'], ['passwordConfirm', 'Подтверждение пароля']] as const).map(([field, title]) => (
          <ShadowInput
            key={field}
            className={styles.field}
            type={'password'}
            lang={'en'}
            onChange={setField(field)}
            value={formData[field]}
            shadowColor={'transparent'}
            placeholder={title}
            error={mismatch || passwordsEmpty}
          />
        ))}
      </div>
      <div className={styles.actions}>
        <AppButton onClick={handleSubmit} disabled={mismatch || loading}>
          Изменить пароль
        </AppButton>
      </div>
    </div>
  )
}
